export default {"src":"/_next/static/image/public/images/ic_video_consult.564320f2e1fdac0aa9f182cf10f4db51.svg","height":20,"width":21};